"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Action = _interopRequireDefault(require("./Action"));

var deleteSelf = function deleteSelf() {
  return new _Action.default({
    type: "delete"
  });
};

var insertAfter = function insertAfter(key, value) {
  return new _Action.default({
    type: "insertAfter",
    keyPath: [key],
    payload: {
      value: value
    }
  });
};

var insertAfterSelf = function insertAfterSelf(value) {
  return new _Action.default({
    type: "insertAfter",
    payload: {
      value: value
    }
  });
};

var insertBefore = function insertBefore(key, value) {
  return new _Action.default({
    type: "insertBefore",
    keyPath: [key],
    payload: {
      value: value
    }
  });
};

var insertBeforeSelf = function insertBeforeSelf(value) {
  return new _Action.default({
    type: "insertBefore",
    payload: {
      value: value
    }
  });
};

var map = function map(updater) {
  return new _Action.default({
    type: "map",
    payload: {
      updater: updater
    }
  });
};

var move = function move(keyA, keyB) {
  return new _Action.default({
    type: "move",
    keyPath: [keyA],
    payload: {
      moveKey: keyB
    }
  });
};

var moveSelf = function moveSelf(keyB) {
  return new _Action.default({
    type: "move",
    payload: {
      moveKey: keyB
    }
  });
};

var push = function push(values) {
  return new _Action.default({
    type: "push",
    payload: {
      values: values
    }
  });
};

var pop = function pop() {
  return new _Action.default({
    type: "pop"
  });
};

var setData = function setData(parcelData) {
  return new _Action.default({
    type: "setData",
    payload: parcelData
  });
};

var setMeta = function setMeta(meta) {
  return new _Action.default({
    type: "setMeta",
    payload: {
      meta: meta
    }
  });
};

var setSelf = function setSelf(value) {
  return new _Action.default({
    type: "set",
    payload: {
      value: value
    }
  });
};

var shift = function shift() {
  return new _Action.default({
    type: "shift"
  });
};

var swap = function swap(keyA, keyB) {
  return new _Action.default({
    type: "swap",
    keyPath: [keyA],
    payload: {
      swapKey: keyB
    }
  });
};

var swapNext = function swapNext(key) {
  return new _Action.default({
    type: "swapNext",
    keyPath: [key]
  });
};

var swapNextSelf = function swapNextSelf() {
  return new _Action.default({
    type: "swapNext"
  });
};

var swapPrev = function swapPrev(key) {
  return new _Action.default({
    type: "swapPrev",
    keyPath: [key]
  });
};

var swapPrevSelf = function swapPrevSelf() {
  return new _Action.default({
    type: "swapPrev"
  });
};

var swapSelf = function swapSelf(keyB) {
  return new _Action.default({
    type: "swap",
    payload: {
      swapKey: keyB
    }
  });
};

var unshift = function unshift(values) {
  return new _Action.default({
    type: "unshift",
    payload: {
      values: values
    }
  });
};

var _default = {
  deleteSelf: deleteSelf,
  insertAfter: insertAfter,
  insertAfterSelf: insertAfterSelf,
  insertBefore: insertBefore,
  insertBeforeSelf: insertBeforeSelf,
  map: map,
  move: move,
  moveSelf: moveSelf,
  push: push,
  pop: pop,
  setData: setData,
  setMeta: setMeta,
  setSelf: setSelf,
  shift: shift,
  swap: swap,
  swapNext: swapNext,
  swapNextSelf: swapNextSelf,
  swapPrev: swapPrev,
  swapPrevSelf: swapPrevSelf,
  swapSelf: swapSelf,
  unshift: unshift
};
exports.default = _default;